import API from "opp-api-lib-js";
import { OGS_API_URL } from "../settings";

export default new API(OGS_API_URL);



// WEBPACK FOOTER //
// ./src/utils/OGSAPI.ts